(() => {
  'use strict';

  function initializeTheme(scope = document) {
    scope.querySelectorAll('[data-mobile-nav]').forEach((menu) => {
      if (menu.dataset.initialized) return;
      menu.dataset.initialized = 'true';
      const trigger = menu.querySelector('summary');
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          trigger.focus();
        }
      });
      menu.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false;
      });
      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => { menu.open = false; });
      });
    });
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-mobile-nav][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  initializeTheme();
  document.addEventListener('shopify:section:load', (event) => initializeTheme(event.target));

  const passwordError = document.querySelector('[data-password-error]');
  if (passwordError) {
    const passwordDisclosure = passwordError.closest('details');
    if (passwordDisclosure) passwordDisclosure.open = true;
    passwordError.focus();
  }

  const feedback = document.querySelector('[data-form-feedback]');
  if (feedback && /customer_posted|contact_posted|form_type/.test(window.location.search)) {
    feedback.focus();
  }
})();
